import React from 'react';
import PropTypes from 'prop-types';
import '../ContactModal.css';
import { Button, DialogActions, Typography } from '@mui/joy';


const StancePage = ({ setPage, setStance, bill }) => {
    return (
        <>
        <Typography level="h3">Where Do You Stand on This Legislation?</Typography>
        <Typography level="body-md">
            Your input helps shape the decisions that impact our community. Be honest and clear about your stance.
        </Typography>
        <DialogActions>
            <Button variant="solid" color="primary" onClick={() => {
                setStance('support');
                setPage('contact');
            }}>
                I support this bill
            </Button>
            <Button variant="solid" color="neutral" onClick={() => {
                setStance('oppose');
                setPage('contact');
            }}>
                I oppose this bill
            </Button>
            <Button variant="plain" color="neutral" onClick={() => setPage('address')}>
                Back
            </Button>
        </DialogActions>
        </>
    );
};

// Prop types for our Component
StancePage.propTypes = {
    setStance: PropTypes.func.isRequired,
    setPage: PropTypes.func.isRequired,
    bill: PropTypes.object.isRequired,
}
 
// Default Props for our Component
StancePage.defaultProps = {
}

export default StancePage;